module.exports = __webpack_public_path__ + "media/images/ssmfi_logo-c49698f662cef88afdfb8905a1a60510.png";